module.exports = __webpack_public_path__ + "static/media/Rocket.317f2e9d.svg";